import {useContext, useEffect, useState} from 'react';

import CaseCard from './CaseCard';
import Search from '../../../base_components/Search';
import Select from '../../../base_components/select/Select';
import Context from '../Context';

import styles from '../../../styles/cases/CasesList.module.scss';

function CasesList(props) {
  const context = useContext(Context);
  const [filteredCases, setFilteredCases] = useState([]);

  const [input, setInput] = useState('');
  const [typePlaceholder, setTypePlaceholder] = useState('Sort by created date');
  const [types, setTypes] = useState({
    'created date': true,
    'modified date': false,
    'name': false,
    'size': false
  });
  const [orderPlaceholder, setOrderPlaceholder] = useState('Ascending order');
  const [order, setOrder] = useState({
    'ascending': false,
    'descending': true
  });

  useEffect(() => {  // filter by input search
    if (input.trim() === '') {
      setFilteredCases([...context.cases]);
      return;
    }

    const timer = setTimeout(() =>
      setFilteredCases([...context.cases.filter(_case => _case.name.includes(input.toLowerCase()))]),
      500
    );
    return () => clearTimeout(timer);
  }, [context.cases, input]);

  useEffect(() => {  // reorder cases
    let newFilteredCases = [...context.cases];
    let newTypePlaceholder = '';

    if (types['created date']) {  // case.created_at
      newFilteredCases.sort((case1, case2) => {
        const date1 = new Date(case1.created_at);
        const date2 = new Date(case2.created_at);
        return order.ascending ? date1 - date2 : date2 - date1;
      });
      newTypePlaceholder = 'Sort by created date';
    } else if (types['modified date']) {  // case.updated_at  TODO update field
      newFilteredCases.sort((case1, case2) => {
        const date1 = new Date(case1.updated_at);
        const date2 = new Date(case2.updated_at);
        return order.ascending ? date1 - date2 : date2 - date1;
      });
      newTypePlaceholder = 'Sort by modified date';
    } else if (types['name']) {  // case.name
      newFilteredCases.sort((case1, case2) => order.ascending ? case1.name.localeCompare(case2.name) : case2.name.localeCompare(case1.name));
      newTypePlaceholder = 'Sort by name';
    } else if (types['size']) {  // case.size  // TODO
      newTypePlaceholder = 'Sort by size';
    }

    setFilteredCases(newFilteredCases);
    setTypePlaceholder(newTypePlaceholder);
    setOrderPlaceholder(order.ascending ? 'Ascending order' : 'Descending order');
  }, [context.cases, types, order]);

  return (
    <div className={styles.casesList + ' ' + props.className}>
      <h2>Cases</h2>
      <Search
        className={styles.search}
        placeholder='Search by name'
        input={input}
        setInput={setInput}
      />
      <div className={styles.selects}>
        <Select
          placeholder={typePlaceholder || 'Sort by'}
          setPlaceholder={setTypePlaceholder}
          items={types}
          setItems={setTypes}
          singleSelect={true}
        />
        <Select
          placeholder={orderPlaceholder || 'Select order'}
          setPlaceholder={setOrderPlaceholder}
          items={order}
          setItems={setOrder}
          singleSelect={true}
        />
      </div>

      <div className={styles.list}>
        {filteredCases.map((_case, index) => (
          <CaseCard key={index} case={_case}/>
        ))}
      </div>
    </div>
  );
}

export default CasesList;